import React, { useEffect } from 'react';
import DialogBox from '@techsoftware/happay-widgets/DialogBox';
import Button from '@techsoftware/happay-widgets/Button';
import history from '../../../utils/history';

export default function CancelPayment(props) {
  const {
    onClose,
    invoiceId,
    open = false,
    cancelSuccess = false,
    cancelPayment,
    rescheduleCancelSuccess,
  } = props;

  const onSubmitClick = () => {
    cancelPayment({ invoice_id: invoiceId });
  };

  useEffect(() => {
    if (cancelSuccess) {
      history.goBack();
      setTimeout(() => {
        rescheduleCancelSuccess('cancel', false);
      }, 500);
    }
  }, [props.cancelSuccess]);

  return (
    <DialogBox
      open={open}
      id="reschedule-payment"
      onClose={onClose}
      title={cancelSuccess ? '' : 'Cancel Payment'}
      actionBorder
      crossIcon
      width="500px"
      dialogStyle={{ justifyContent: 'flex-start', minHeight: '220px' }}
      dialogTitleContainerStyle={{ padding: '20px 30px', fontWeight: '600' }}
      bodyStyle={{ overflow: 'visible' }}
      actionStyle={{ zIndex: 0 }}
      actions={
        <div>
          <Button
            type="button"
            text="No"
            variant="secondary"
            className="margin-r-20"
            onClick={onClose}
          />
          <Button
            type="button"
            text={cancelSuccess ? 'Close' : 'Yes'}
            onClick={onSubmitClick}
          />
        </div>
      }
    >
      <div className="padding-lr-30">
        <div>Are you sure you want to cancel this payment?</div>
      </div>
    </DialogBox>
  );
}
